import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { ref } from 'vue'

import { useAuth } from 'src/composables/app/useAuth'

import { companiesService } from 'src/services/api/companies.service'
import { idbService } from 'src/services/app/idb.service'
import { log } from 'src/services/app/log.service'
import { notifyService } from 'src/services/app/notify.service'
import { STORAGE_KEYS } from 'src/services/consts/api.const'
import { NOTIFICATION_MESSAGES } from 'src/services/consts/notification.const'

const showCreateModal = ref(false)

export function useCreateCompanyMutation() {
  const queryClient = useQueryClient()
  const { user } = useAuth()

  const createCompanyMutation = useMutation({
    mutationFn: async ({ companyName, fullAiAssessment, startSubprocessorList }) =>
      companiesService.createCompany({
        companyName,
        fullAiAssessment,
        startSubprocessorList,
      }),
    onSuccess: async (newCompany) => {
      notifyService.success(NOTIFICATION_MESSAGES.success.create)
      const companiesData = queryClient.getQueryData([STORAGE_KEYS.COMPANIES, user.value?.id])
      const companies = companiesData ? JSON.parse(JSON.stringify(companiesData)) : null

      if (companies) {
        const newCompanies = [newCompany, ...companies]
        queryClient.setQueryData([STORAGE_KEYS.COMPANIES, user.value?.id], newCompanies)
        await idbService.setData(STORAGE_KEYS.COMPANIES, newCompanies)
      } else {
        // If no companies data exists yet, invalidate the query to fetch fresh data
        await queryClient.invalidateQueries([STORAGE_KEYS.COMPANIES])
      }

      return newCompany
    },
    onError: (error) => {
      notifyService.error(NOTIFICATION_MESSAGES.error.create)
      log.error('Failed to create company', error)
      throw error
    },
  })

  return {
    createCompany: createCompanyMutation.mutateAsync,
    isCreatingCompany: createCompanyMutation.isPending,
    createCompanyError: createCompanyMutation.error,
    showCreateModal,
  }
}
